module.exports = __webpack_public_path__ + "static/media/UnitedSansSmCdBd.ad107df9.woff2";